import React from "react";
import Hero from "../Component/HeroSection";
import AboutSection from "../Component/AboutSection";
import OurProgramsSection from "../Component/OurProgram";
import FeaturesSection from "../Component/FeaturesSection";
import WhyChooseUsSection from "../Component/WhyChooseUsSection"
import Ourteacherssection from "../Component/Ourteacherssection";
import GetStartedSection from "../Component/Getstartedsection";
import FAQSection from "../Component/Faqsection";
import TestimonialsSection from "../Component/Testimonial";
import SeoQuickLinks from "../Component/SeoQuickLinks";

const Homepage = () => {
  return (
    <div>
      <section id="home">
        <Hero />
      </section>
      <section id="about">
        <AboutSection />
      </section>
      <section id="programs">
        <OurProgramsSection />
      </section>
      <FeaturesSection />
      <WhyChooseUsSection />
      {/* <Ourteacherssection /> */}
      <FAQSection />
      <section id="contact">
        <GetStartedSection />
      </section>
      <section id="blog">
        <TestimonialsSection />
      </section>
       <SeoQuickLinks />
    </div>
  );
};

export default Homepage;
        
   
